import {
  EnvSection,
  EnvTopic,
} from '@/domain/impact-env/entities/question.entity';
import {
  EssSection,
  EssTopic,
} from '@/domain/impact-ess/entities/question.entity';
export type Sector = (typeof SectorValues)[number];
export const SectorValues = [
  '',
  'ANY',
  'TEAM',
  'ARTISTS',
  'PUBLIC',
  'SITE',
] as const;

export type ScoreType = 'co2' | 'ess' | 'env';

export enum QuestionType {
  NUMERIC = 'numeric',
  PERCENT_SLIDER = 'percent_slider',
  FACTOR = 'factor',
  FACTOR_CAPACITY = 'factor_capacity',
  FACTOR_PERCENTAGE = 'factor_percentage',
  FACTOR_MINISTRY = 'factor_ministry',
  FACTOR_MINORITY = 'factor_minority',
  FRACTION = 'fraction',
  FRACTION_CAPACITY = 'fraction_capacity',
  MULTISELECT = 'multiselect',
  BOOLEAN = 'boolean',
  SELECT = 'select',
}

export enum PossibleQuestionModelType {
  ESS = 'ESS',
  ENV = 'ENV',
}

export type QuestionTopicType<T> = T extends 'ESS' ? EssTopic : EnvTopic;
export type QuestionSectionType<T> = T extends 'ESS' ? EssSection : EnvSection;
export type Answer = {
  id: number;
  paramId: string;
  value: string;
  score?: number;
  projectId?: number;
};

export interface Question<T extends PossibleQuestionModelType = never> {
  paramId: string;
  topic: QuestionTopicType<T>;
  section: QuestionSectionType<T>;
  type: QuestionType;
  answer?: Answer;
  isHidden: boolean;
  title: { fr?: string; en?: string };
  helpText?: { fr?: string; en?: string };
  options?: {
    optionId: string;
    title: { fr?: string; en?: string };
  }[];
  fields?: {
    title: { fr?: string; en?: string };
  }[];
}
